import { connect } from "react-redux";
import { Formik, Form } from "formik";
import React, { useRef, useState } from "react";
import { Modal, Row } from "react-bootstrap";

import { EMPTY_STRING, inventoryConstants } from "../../../../constants";
import { addCustomItemValidationSchema } from "../../../../shared/validationSchema/validationSchema";
import {
  handleCashOfferValues,
  getMarginDropdownValue,
  handleTradeOfferValues,
  getTypeOrCategoryObject,
  getCustomProductIfExist,
  handleCalculateEachProductPercentage,
  getBatchCustomItemInitialValues,
  getBatchCustomItemSubmitMapping,
  getAddInventoryPricePayloadObject,
} from "../../../../shared/utility";
import CustomInventoryComponent from "../../../../shared/components/inventory/CustomInventoryComponent";

const AddTradeBatchCustomItem = ({
  inventory,
  addToCart,
  shopifySettings,
  tradeDiscount,
  itemOrganization,
  editCustomProduct,
  isCustomItemModal,
  toggleCustomItemModal,
  invoiceBatchInventory,
  setInvoiceBatchInventory,
}) => {
  //-------Reducer
  const { customTypes, customCategories, customSubCategories } =
    itemOrganization;
  const { productTags } = inventory;
  //-------Reducer
  const { tradeinMargin } = tradeDiscount;

  //------useref
  const formikRef = useRef();

  //--------useState
  const [customProductSelectedTags, setCustomProductSelectedTags] = useState(
    editCustomProduct
      ? editCustomProduct?.tags?.filter(
          (tag) => tag !== inventoryConstants.CUSTOM_ITEM_TAG
        )
      : []
  );
  const [ratio, setRatio] = useState(
    tradeinMargin?.globalMargin?.tradeinMarginPercentage /
      tradeinMargin?.globalMargin?.cashMarginPercentage
  );
  const [, setMarginObject] = useState(tradeinMargin?.globalMargin);
  const [isProductExist, setIsProductExist] = useState(false);

  //-------inital values for customItem
  const customItemInitialValues = {
    cashOffer: editCustomProduct?.cashOffer || 0,
    tradeOffer: editCustomProduct?.tradeOffer || 0,
    ...getBatchCustomItemInitialValues(
      editCustomProduct,
      customTypes,
      customCategories,
      customSubCategories,
      shopifySettings
    ),
  };

  //-------Handle Hide Modal
  const handleHideModal = () => {
    toggleCustomItemModal();
  };

  //-------handle Custom Item Submit
  const handleCustomItemSubmit = (values) => {
    const itemToAdd = {
      ...getBatchCustomItemSubmitMapping(
        values,
        customTypes,
        customCategories,
        customSubCategories,
        customProductSelectedTags,
        editCustomProduct
      ),

      imgUrl: editCustomProduct?.imgUrl || EMPTY_STRING,
      cashOffer: values.cashOffer,
      tradeOffer: values.tradeOffer,
    };

    const { quantity, onlineQuantity } =
      getAddInventoryPricePayloadObject(values);

    if (editCustomProduct?.id || editCustomProduct?.id === 0) {
      addToCart({
        ...editCustomProduct,
        ...itemToAdd,
        inStockQuantity: quantity,
        onlineQuantity,
      });
    } else {
      setInvoiceBatchInventory(
        handleCalculateEachProductPercentage([
          ...invoiceBatchInventory,
          {
            ...itemToAdd,
            id: invoiceBatchInventory?.length,
            inStockQuantity: quantity,
            onlineQuantity,
            isDataFetching: true,
          },
        ])
      );
    }
    handleHideModal();
  };

  //-------handle Track Quantity Change
  // const handleTrackQuantityChange = (name, value, setFieldValue) => {
  //   setFieldValue("quantity", value ? 1 : "");
  // };

  //-------onselectedtagchange
  const onCustomProductSelectTagsChange = (selectedTags) => {
    const selectedTagList = selectedTags.map((tag) => tag.label);
    setCustomProductSelectedTags(selectedTagList);
  };

  //------- handle Product Type Change
  const handleTypeChange = (option, setFieldValue, values) => {
    setFieldValue("type", option.value);
    setFieldValue("condition", EMPTY_STRING);
    setFieldValue("category", EMPTY_STRING);
    setFieldValue("subCategory", EMPTY_STRING);

    let tempRes = getMarginDropdownValue(
      0,
      tradeinMargin,
      option.label,
      {
        consoleName: EMPTY_STRING,
        genre: EMPTY_STRING,
      },
      false
    );
    setRatio(
      tempRes.marginObject.tradeinMarginPercentage /
        tempRes.marginObject.cashMarginPercentage
    );
  };

  //------- handle Category Change
  const handleCategoryChange = (option, setFieldValue, values) => {
    setFieldValue("category", option.value);
    setFieldValue("subCategory", EMPTY_STRING);
    let tempRes = getMarginDropdownValue(
      0,
      tradeinMargin,
      getTypeOrCategoryObject(customTypes, values.type)?.productType,
      {
        consoleName: option.label,
        genre: EMPTY_STRING,
      },
      false
    );
    setMarginObject(tempRes);
    setRatio(
      tempRes.marginObject.tradeinMarginPercentage /
        tempRes.marginObject.cashMarginPercentage
    );
  };

  //------- handle Sub-Category Change
  const handleSubCategoryChange = (option, setFieldValue, values) => {
    setFieldValue("subCategory", option.value);
    let tempRes = getMarginDropdownValue(
      0,
      tradeinMargin,
      getTypeOrCategoryObject(customTypes, values.type)?.productType,
      {
        consoleName: getTypeOrCategoryObject(
          customCategories,
          values.category_name
        )?.name,
        genre: option.label,
      },
      false
    );
    setMarginObject(tempRes);
    setRatio(
      tempRes.marginObject.tradeinMarginPercentage /
        tempRes.marginObject.cashMarginPercentage
    );
  };
  return (
    <Modal
      show={isCustomItemModal}
      size="lg"
      onHide={handleHideModal}
      animation={true}
      centered
      backdrop="static"
      className="add-inventory-modal"
    >
      <Modal.Header closeButton className="add-inventory-modal-header">
        <Modal.Title>
          <span className="add-inventory-modal-header-name">
            {editCustomProduct ? "Edit Custom Item" : "Add Custom Item"}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="add-inventory-modal-body p-1">
        <Row className="m-0">
          <Formik
            initialValues={customItemInitialValues}
            validate={addCustomItemValidationSchema}
            onSubmit={handleCustomItemSubmit}
          >
            {({ values, setFieldValue }) => {
              setIsProductExist(
                getCustomProductIfExist(
                  values,
                  customTypes,
                  customCategories,
                  editCustomProduct,
                  customSubCategories,
                  customProductSelectedTags,
                  true
                )
              );
              return (
                <Form className="px-0">
                  <Row className="m-0">
                    <CustomInventoryComponent
                      values={values}
                      formikRef={formikRef}
                      productTags={productTags}
                      setFieldValue={setFieldValue}
                      isProductExist={isProductExist}
                      handleHideModal={handleHideModal}
                      isCustomItemTab={true}
                      setIsCustomItemTab={() => {}}
                      customProductSelectedTags={customProductSelectedTags}
                      onCustomProductSelectTagsChange={
                        onCustomProductSelectTagsChange
                      }
                      isTradeCustomItem={true}
                      handleTypeChange={handleTypeChange}
                      handleCategoryChange={handleCategoryChange}
                      handleSubCategoryChange={handleSubCategoryChange}
                      isEditCustomItemModal={!editCustomProduct}
                      ratio={ratio}
                      handleCashOfferValues={handleCashOfferValues}
                      handleTradeOfferValues={handleTradeOfferValues}
                      isProductEdit={!editCustomProduct}
                    />
                  </Row>
                </Form>
              );
            }}
          </Formik>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  inventory: state.inventory,
  tradeDiscount: state.tradeDiscount,
  itemOrganization: state.itemOrganization,
  shopifySettings: state.shopify.shopifySettings,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({});

//-------Export AddInvoice Component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddTradeBatchCustomItem);
